import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactListComponent } from './contact-list/contact-list.component';
import { FormsModule } from '@angular/forms';
import { ContactListEditComponent } from './contact-list-edit/contact-list-edit.component';
import { CoreModule } from '../core/core.module';
import { BasicsModule } from '../basics/basics.module';
import { ContactComponent } from './contact/contact.component';
import { ContactEditComponent } from './contact-edit/contact-edit.component';
import { ContactDeleteComponent } from './contact-delete/contact-delete.component';
import { ContactListAssignComponent } from './contact-list-assign/contact-list-assign.component';
import { ContactListAssignMessageDialogComponent } from './contact-list-assign-message-dialog/contact-list-assign-message-dialog.component';
import { ContactListContactsComponent } from './contact-list/contact-list-contacts/contact-list-contacts.component';
import { ContactListContactsEditComponent } from './contact-list/contact-list-contacts-edit/contact-list-contacts-edit.component';
import { ContactSearchComponent } from './contact-search/contact-search.component';
import { NavModule } from '../nav-menu/nav.module';
import { ImportFilesComponent } from './import-files/import-files.component';
import { UploadFileSelectContactlistComponent } from './import-files/upload-file-select-contactlist/upload-file-select-contactlist.component';
import { MapTableCellsComponent } from './import-files/map-table-cells/map-table-cells.component';
import { DisplayTableWithFlagsComponent } from './import-files/display-table-with-flags/display-table-with-flags.component';
import { DisplaySuccessImportComponent } from './import-files/display-success-import/display-success-import.component';
import { UnsubscribedContactsComponent } from './contact-list/contact-list-contacts/unsubscribed-contacts/unsubscribed-contacts.component';

@NgModule({
  declarations: [
    ContactListComponent,
    ContactListEditComponent,
    ContactComponent,
    ContactEditComponent,
    ContactDeleteComponent,
    ContactListAssignComponent,
    ContactListAssignMessageDialogComponent,
    ContactListContactsComponent,
    ContactListContactsEditComponent,
    ContactSearchComponent,
    ImportFilesComponent,
    UploadFileSelectContactlistComponent,
    MapTableCellsComponent,
    DisplayTableWithFlagsComponent,
    DisplaySuccessImportComponent,
    UnsubscribedContactsComponent
  ],
  imports: [
    NavModule,
    CommonModule,
    FormsModule,
    CoreModule,
    BasicsModule
  ],

  entryComponents: [ContactListEditComponent]

})
export class ContactsModule { }
